import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { lensApi } from '../axios';

/** GET /v1/lens/devices — list all registered Lens devices for the company */
export const useLensDevices = () => useQuery({
  queryKey: ['lens', 'devices'],
  queryFn: () => lensApi.get('/v1/lens/devices').then((r) => r.data),
  refetchInterval: 60 * 1000,
});

/** POST /v1/lens/devices — register a new Lens device, returns one-time device token */
export const useRegisterLensDevice = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (payload) => lensApi.post('/v1/lens/devices', payload).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['lens', 'devices'] }),
  });
};

/** POST /v1/lens/devices/:id/rotate-token — invalidates current token, returns new one-time token */
export const useRotateLensToken = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id }) => lensApi.post(`/v1/lens/devices/${id}/rotate-token`).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['lens', 'devices'] }),
  });
};

/** GET /v1/lens/visitors — paginated visitor log */
export const useVisitorLog = (params) => useQuery({
  queryKey: ['lens', 'visitors', params],
  queryFn: () => lensApi.get('/v1/lens/visitors', { params }).then((r) => r.data),
});
